import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CountdowntimerComponent } from "./countdowntimer.component";

@NgModule({
  declarations: [
    CountdowntimerComponent,
  ],
  exports: [
    CountdowntimerComponent,
    CommonModule
  ]
})
export class CountDownModule { }
